import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

/**
 * 添加/修改交易记录
 * @param {Object} transactionData - 交易数据对象
 * @param {number} transactionData.id - 交易ID（修改时必填，新增时不填）
 * @param {number} transactionData.user_id - 用户ID
 * @param {number} transactionData.merchant_account_id - 商户账户ID
 * @param {string} transactionData.transaction_type_detail - 交易类型详情（如：ecommerce, offline, other）
 * @param {string} transactionData.receiving_account - 收款账号
 * @param {string} transactionData.actual_number - 实际编号
 * @param {string} transactionData.platform_name - 平台名称
 * @param {string} transactionData.shop_name - 店铺名称
 * @param {number} transactionData.amount - 金额
 * @param {number} transactionData.arrival_amount - 到账金额
 * @param {string} transactionData.arrival_currency - 到账币种
 * @param {number} transactionData.credited_amount - 入账金额
 * @param {string} transactionData.credited_currency - 入账币种
 * @param {number} transactionData.fee - 手续费
 * @param {string} transactionData.fee_currency - 手续费币种
 * @param {string} transactionData.payer_name - 付款人名称
 * @param {string} transactionData.description - 描述
 * @param {string} transactionData.remark - 备注
 * @returns {Promise}
 */
export const add_modify_transaction = (transactionData) => {
  return api.post(`${ApiEndpointConstants.ADD_TRANSACTION}`, transactionData);
};
